import React, { Component, DetailedHTMLProps, HTMLAttributes } from 'react'
import { observer } from 'mobx-react'
import { CreateOrEditDiscount, ILocation } from '@getgreenline/homi-shared'
import { Input, Select } from 'antd'
import TextArea from 'antd/lib/input/TextArea'
import { SingleCollapsibleContainer } from '../../../../../components/ResponsiveContainer/SingleCollapsibleContainer'
import { ResponsiveRow } from '../../../../../components/ResponsiveContainer/ResponsiveRow'
import { CollapseProps } from 'antd/lib/collapse'
import { getPopupContainer } from '../../../../../utilities/helpers'
import { Typography } from 'antd-v4'
import { CopyOutlined } from '@ant-design/icons'
const { Text } = Typography
interface Props {
  discount: CreateOrEditDiscount
  collapseProps: CollapseProps
  locations: ILocation[]
}

@observer
export class AddDiscountGeneral extends Component<Props> {
  handleLocationsChange = (value: number[]) => {
    this.props.discount.setLocationIds(value)
  }

  get locationSelectOptions() {
    return this.props.locations.map((location) => {
      return (
        <Select.Option key={location.id} value={location.id} label={location.name}>
          {location.name}
        </Select.Option>
      )
    })
  }

  get locationCaption() {
    const numberOfLocations = this.props.discount.locationIds.length
    const isMultiple = numberOfLocations > 1

    return `${numberOfLocations} location${isMultiple ? 's are' : ' is'} selected`
  }

  render() {
    const { collapseProps, discount } = this.props
    const defaultColumnStyles = { display: 'flex', flexDirection: 'column' } as DetailedHTMLProps<
      HTMLAttributes<HTMLDivElement>,
      HTMLDivElement
    >
    return (
      <SingleCollapsibleContainer
        collapseProps={collapseProps}
        panelProps={{ header: 'General', key: 'general' }}
        defaultActive
      >
        <div style={{ ...defaultColumnStyles, gap: 16 }}>
          <section style={{ ...defaultColumnStyles, gap: 4 }}>
            {discount?.id && (
              <Text
                copyable={{
                  text: discount.id.toString(),
                  icon: <CopyOutlined />,
                  tooltips: ['Copy', 'Copied'],
                }}
                key={discount.id}
                style={{ width: '300px', wordWrap: 'break-word', display: 'inline-block' }}
              >
                Discount ID: {discount.id}
              </Text>
            )}
            <ResponsiveRow
              labelText={
                <>
                  <strong>Name</strong> <span className='required'>* required</span>
                </>
              }
            >
              <Input
                className='input-field'
                value={discount.name}
                onChange={(e) => {
                  discount.setName(e.target.value)
                }}
              />

              <div className='caption'>
                Give the discount a name that makes sense and is easy to find
              </div>
            </ResponsiveRow>
          </section>

          <ResponsiveRow labelText={<strong>Description</strong>}>
            <TextArea
              className='input-field'
              value={discount.description || undefined}
              onChange={(e) => {
                discount.setDescription(e.target.value)
              }}
            />
          </ResponsiveRow>

          <ResponsiveRow labelText={<strong>Locations</strong>}>
            <Select<number[]>
              className='input-field'
              showArrow={true}
              allowClear
              mode='multiple'
              placeholder={discount.locationIds.length === 0 && 'All locations'}
              defaultValue={discount.locationIds}
              onChange={this.handleLocationsChange}
              optionFilterProp='children'
              getPopupContainer={getPopupContainer}
            >
              {this.locationSelectOptions}
            </Select>
            {discount.locationIds.length > 0 && (
              <div className='caption'>{this.locationCaption}</div>
            )}
          </ResponsiveRow>
        </div>
      </SingleCollapsibleContainer>
    )
  }
}
